// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flat-button_26f9e8d1 {
  margin: 0;
  padding: 0;
  border: 0;
}
.flat-button_26f9e8d1 {
  position: relative;
  display: inline-block;
  background: none;
  overflow: visible;
  touch-action: manipulation;
  text-align: center;
  cursor: pointer;
  text-transform: none;
  height: auto;
  font-weight: 400;
}
button.flat-button_26f9e8d1 {
  -webkit-appearance: button;
}
.flat-button__content_26f9e8d1 {
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
}
.flat-button__caption_26f9e8d1 {
  position: relative;
  flex-grow: 1;
  flex-basis: auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.flat-button__caption_26f9e8d1:has(a:focus-visible) {
  outline-style: solid;
  outline-offset: 1px;
  outline-width: 2px;
  outline-color: #1d5080;
  box-shadow: 0 0 0 4px #fff;
}
.flat-button__caption_26f9e8d1:has(a:focus-visible) a:focus-visible {
  outline: none;
  box-shadow: none;
}
.flat-button_26f9e8d1 .flat-button__icon_26f9e8d1 {
  min-width: 1.167rem;
  margin-right: 0.334rem;
}
.flat-button_26f9e8d1 .flat-button__icon_right_26f9e8d1 {
  margin-right: 0;
  margin-left: 0;
}
.flat-button_busy_26f9e8d1:disabled.flat-button_dark-mode_26f9e8d1 {
  color: #fff !important;
}
.flat-button_26f9e8d1:hover .flat-button__caption_26f9e8d1,
.flat-button_26f9e8d1:active .flat-button__caption_26f9e8d1 {
  text-decoration: underline;
}
.flat-button_26f9e8d1:disabled {
  background-color: transparent;
  text-shadow: none;
  box-shadow: none;
}
.flat-button_26f9e8d1:disabled .flat-button__caption_26f9e8d1 {
  text-decoration: none;
}
.flat-button_26f9e8d1 {
  color: #26649e;
}
.flat-button_26f9e8d1.flat-button_dark-mode_26f9e8d1 {
  color: #fff;
}
.flat-button_26f9e8d1.flat-button_secondary_26f9e8d1 {
  color: #11304d;
}
.flat-button_26f9e8d1.flat-button_secondary_26f9e8d1.flat-button_dark-mode_26f9e8d1 {
  color: #fff;
}
.flat-button_26f9e8d1:hover {
  color: #267479;
}
.flat-button_26f9e8d1:hover.flat-button_dark-mode_26f9e8d1 {
  color: #c4edeb;
}
.flat-button_26f9e8d1:active {
  color: #1a4f52;
}
.flat-button_26f9e8d1:active.flat-button_dark-mode_26f9e8d1 {
  color: #40c2c9;
}
.flat-button_26f9e8d1:disabled {
  color: #c1c8cd;
}
.flat-button_26f9e8d1:disabled.flat-button_dark-mode_26f9e8d1 {
  color: #6185a6;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flat-button": `flat-button_26f9e8d1`,
	"flat-button__content": `flat-button__content_26f9e8d1`,
	"flat-button__caption": `flat-button__caption_26f9e8d1`,
	"flat-button__icon": `flat-button__icon_26f9e8d1`,
	"flat-button__icon_right": `flat-button__icon_right_26f9e8d1`,
	"flat-button_busy": `flat-button_busy_26f9e8d1`,
	"flat-button_dark-mode": `flat-button_dark-mode_26f9e8d1`,
	"flat-button_secondary": `flat-button_secondary_26f9e8d1`
};
export default ___CSS_LOADER_EXPORT___;
